<template>
	<div class="w95mg flexcss dn" style="padding-top:20px">
		<div class="fl" style="width: 48%;" v-if="showPie">
			<div class="land-ecahrt-title">
				<h5 :class="cityInvestType == 1 ? 'current title fl':'title fl'" @click="cityInvestPieEchart(1,curtitle.name1)">{{curtitle.name1}}</h5>
				<h5 :class="cityInvestType == 2 ? 'current title fl':'title fl'" @click="cityInvestPieEchart(2,curtitle.name2)">{{curtitle.name2}}</h5>
			</div>
			<div :id="curtitle.piename" class="echart-line-box" :style="'width:'+echartWidth2+'px;'"></div>
		</div>
		<div :class="showPie?'fr':'fl'" style="width: 48%;" v-if="showLine">
			<div class="oh land-ecahrt-title">
				<h5 :class="yearInvestType == 1 ? 'current title fl':'title fl'"  @click="yearInvestLineEchart(1,curtitle.name3)">{{curtitle.name3}}</h5>
				<h5 :class="yearInvestType == 2 ? 'current title fl':'title fl'"  @click="yearInvestLineEchart(2,curtitle.name4)">{{curtitle.name4}}</h5> 
			</div>
			<div :id="curtitle.linename" class="echart-line-box" :style="'width:'+echartWidth2+'px;'"></div> 
		</div> 
	</div>
</template>

<script>
	export default {
		props:{
			data:{type:Object,request:true},
			detailType:{type:Number,request:true,default:1},
			showPie:{type:Boolean,request:false,default:true},
			showLine:{type:Boolean,request:true,default:false},
			// pieIdName:{type:String,require:true,default:'nadixinxi-pie'},
			// lineIdName:{type:String,require:true,default:'nadixinxi-line'},
		},
		data(){
			return{
				echartWidth2:document.body.offsetWidth*0.8728*0.95*0.48,
				cityInvestType:1,
				yearInvestType:1,
				cityInvestData: [],
				yearInvestData: [],
				titlelist:[
					{type:1,name1:"投资事件省份分布",name2:"投资事件城市分布",name3:"历年投资事件",name4:"近期投资事件",linename:"tzsj-line",piename:"tzsj-pie",keyword:"投资事件"},
					{type:2,name1:"对外投资省份分布",name2:"对外投资城市分布",name3:"历年对外投资",name4:"近期对外投资",linename:"dwtz-line",piename:"dwtz-pie",keyword:"对外投资"},
					{type:3,name1:"控制企业省份分布",name2:"控制企业城市分布",name3:"",name4:"",linename:"kzqy-line",piename:"kzqy-pie",keyword:"控制企业"},
				],
				curtitle:{type:1,
					name1:"投资事件省份分布",
					name2:"投资事件城市分布",
					name3:"历年投资事件",
					name4:"近期投资事件",
					linename:"tzsj-line",
					piename:"tzsj-pie",
					keyword:"投资事件"
				},
			}
		},
		created() {
			var list1=this.titlelist.filter(list=>{
				return list.type== this.detailType;
			});
			this.curtitle=list1[0];
		},
		mounted() {
			
			if(this.showLine){
				this.yearInvestLineEchart(1,'历年投资事件','个');
			} 
			this.cityInvestPieEchart(1,'投资事件省份分布');
		},
		methods: {
			//城市省份分布饼图
			cityInvestPieEchart(type,title){
				this.cityInvestType=type;
				var data=[];
				if(type == 1){
					data=this.data.province;
				}else if(type == 2){
					data=this.data.city;
				}
				data.forEach(list=>{
					list.value=list.num;
				}); 
				// console.log('landpiefun',data)
				this.landpiefun(data,title,'个');
			},
			landpiefun(serdata1,title,unit){
			unit = unit?unit:'个';
			var mypiechart = echarts.init(document.getElementById(this.curtitle.piename));   
			var 	option = {
					title: {
						text:'',
						left: 20,
						textStyle:{fontSize:16,color:"#666"},
						top:10,
					},
					//悬浮显示
					tooltip: {
						trigger: 'item',
						formatter: function(params) {
							// console.log(params)
							let rethtml = params.marker + params.name + " : " + params.value +' '+unit ;
							return rethtml;
						},
					},
					// color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
					//图例
					legend: {
						show:false,
						left: 'center',
						bottom:10,
						itemWidth:6,itemHeight:6
					},
					
					series: [{
						name: '',
						type: 'pie',
						radius: '60%',
						data:  serdata1, 
						label: {show: true,position: 'outside',color:'#000',fontSize:12,formatter: '{b}:{d}%',},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				}; 
				mypiechart.setOption(option); 
			},
			//历年今年事件分布 
			yearInvestLineEchart(type1,title,unit){
				unit = unit?unit:'个';
				this.yearInvestType=type1;
					var mylinechart = echarts.init(document.getElementById(this.curtitle.linename));
					var xdata=[],ydata=[];
					// var serdata=this.lineReturnData(data,type1);   
					var serdata=[];
					if(type1 == 1){
							serdata=this.data.year;
					}else if(type1 == 2){
							serdata=this.data.month;
					}
					for(var n =0;n<serdata.length;n++){
						xdata.push(serdata[n].date);
						ydata.push(serdata[n].num);
					} 
					var timeunit=type1>1?'月':'年';
					var  yaxirName=this.curtitle.keyword+'（个）'
					// console.log(xdata,ydata); 
						var	option = {
								title: {
									text: '',
									left: 'center',
									top:10,
								},
								color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
								// tooltip: {
								// 	trigger: 'item'
								// },
								tooltip: {
									trigger: 'item',
									backgroundColor: 'rgba(255,255,255,0.9)',
									borderColor: '#ddd',
									borderWidth: '1',
									textStyle: {
									color: '#000',
									fontSize: 14, 
									}, 
									formatter: function(params) { 
										let rethtml = params.marker + params.name + timeunit+title+"：" + params.value +unit ;
										return rethtml;
									}
								},
								legend: {  
								show:true,
								bottom:10,
								},
								label: {show: true },
							  xAxis: {
							    type: 'category',
							    data: xdata,
							  },
							  yAxis: {
							    type: 'value',
											name: yaxirName,
							  },
							  series: [
							    {
												name:'',
							      data: ydata,
							      type: 'line',
													smooth: true
							    }
							  ]
							};
							mylinechart.setOption(option); 
			},
			lineReturnData(data,type1){ 
				//折线图 将时间提取出来 
				 var serdata=[];//todo 每个月要进行更新
				 let yeararry=['2023-01','2023-02','2023-03','2023-04','2023-05','2023-06','2023-07','2023-08','2023-09','2023-10','2023-11','2023-12',];
					let yearstr=yeararry.join("%");
					var yeardata=[];
					for(var i=0;i<yeararry.length;i++){
						yeardata.push({name:yeararry[i],value:0});
					}
					if(type1>1){
						//近期 从现实推算到一年的数据   
						for(var i=0;i<data.length;i++){
								data[i].datetime=data[i].yymmdd.substring(0,7);
							// if(type=='land'){
							// 	data[i].datetime=data[i].time.substring(0,7);   
							// 	data[i].Linevalue=data[i].size; 
							// }else if(type=='project'){
							// 	data[i].datetime=data[i].date.substring(0,7); 
							// 	data[i].Linevalue=data[i].money/10000; 
							// }else if(type== 'finance'){
							// 	data[i].datetime=data[i].date.substring(0,7);
							// 	data[i].Linevalue=data[i].money/10000; 
							// }
						} 
						data=data.filter(list=>{
							 return yearstr.indexOf(list.datetime)>-1;
						})
						console.log('yeardata0',data)
					}else{
						for(var i=0;i<data.length;i++){
							data[i].datetime=data[i].time.substring(0,4);
							// data[i].Linevalue=data[i].size; 
							// if(type=='land'){
							// 	data[i].datetime=data[i].time.substring(0,4);   
							// 	data[i].Linevalue=data[i].size; 
							// }else if(type=='project'){
							// 	data[i].datetime=data[i].date.substring(0,4); 
							// 	data[i].Linevalue=data[i].money/10000; 
							// }else if(type== 'finance'){
							// 	data[i].datetime=data[i].date.substring(0,4);
							// 	data[i].Linevalue=data[i].money/10000; 
							// }
						} 
					}
					
					
				 var Num=[0];//存储数据出现的次数
				 var str=[0];//存储不重复的数据， 
				 // var amountArry=[0];//存储不重复的数据， 
				 var x=0;
				 for(var i=0;i<data.length;i++){
				     var temp=data[i].datetime//将要统计的数据赋值给temp
									// var Linevalue1=data[i].Linevalue; 
				     var Num1=1;
				     for(var j=i+1;j<data.length;j++){
				         if(temp==data[j].datetime){//若数组后续中的数据与temp相同时，进行该代码段
				             Num1++;//项目/拿地数量叠加
																	// Linevalue1+=data[j].Linevalue;//拿地面积和项目金额叠加 上面已经将参数值统一了
				         }
				     }
				     var answer=(str.indexOf(temp)>-1)//判断str数组中是否含有temp数据，存在返回true否则false
				     if(!answer){//若数据不存在时，进行此程序，将数据存储起来
				         str[x]=temp//str与Num的下角标互相对应
				         Num[x]=Num1
				         // amountArry[x]=Linevalue1;
				         x++
				     }
				 }
				 // console.log("数组str的长度为："+str.length+"</br>"); 
				 for(var k=0;k<str.length;k++){
				   // console.log("字符："+str[k]+" 出现次数为："+Num[k]+"</br>");  
							// if(type1 == 1 || type1 == 3){
							// 	serdata.push({name:str[k],value:amountArry[k].toFixed(1) });
							// }else if(type1 == 2|| type1 == 4){
							// 	serdata.push({name:str[k],value:Num[k]});
							// } 
							serdata.push({name:str[k],value:Num[k]});
				 		this.sortKey2(serdata,'name');  
				 } 
					if(type1>1){
						for(var i=0;i<serdata.length;i++){
							let serMonth=serdata[i].name;
							for(var d=0;d<yeardata.length;d++){
								if(serMonth == yeardata[d].name){
									yeardata[d].value=serdata[i].value;
								} 
							}  
						} 
						serdata=yeardata;
					}
				return serdata; 
			},
		}
	};
</script>

<style lang="scss">
 
</style>